import { render, staticRenderFns } from "./华龙区轮播新闻.vue?vue&type=template&id=3c8032f3&scoped=true"
import script from "./华龙区轮播新闻.vue?vue&type=script&lang=js"
export * from "./华龙区轮播新闻.vue?vue&type=script&lang=js"
import style0 from "./华龙区轮播新闻.vue?vue&type=style&index=0&id=3c8032f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8032f3",
  null
  
)

export default component.exports